import { useMatch } from "react-router";
import isEmpty from "lodash/isEmpty";
import { Path } from "utils/constants/paths.constants";

const useSkipWidgetLayout = () => {
  const pathMatches = [
    Path.ProjectECTD,
    Path.ProjectDocument,
    Path.ProjectHAQ,
    Path.ProjectStructuredDocument,
  ]
    .map(useMatch)
    .filter((pathMatch) => pathMatch);

  return {
    isWidgetLayoutSkipped: !isEmpty(pathMatches),
  };
};

export default useSkipWidgetLayout;
